import { coopLogic } from './coop.logic';

import { CoopHostView, CoopProjectorView, CoopStudentView } from './CoopViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const coopPlugin: ActivityPlugin<'coop'> = {

  ...coopLogic,

  displayName: GAME_MODE_CATALOG.coop.displayName,

  icon: GAME_MODE_CATALOG.coop.icon,

  HostView: CoopHostView,

  StudentView: CoopStudentView,

  ProjectorView: CoopProjectorView,

};



export { demoCoopPayload } from './coop.logic';

